import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import './style.css'
import Dashboard from './components/Dashboard.vue'
import ApiKeys from './components/ApiKeys.vue'
import Plans from './components/Plans.vue'
import FunctionTest from './components/FunctionTest.vue'
import AzureStorage from './components/AzureStorage.vue'
import ShopTest from './components/ShopTest.vue'
import Login from './views/Login.vue'

// EasyAuth handles all authentication - no MSAL needed!

const routes = [
  { path: '/login', component: Login },
  { path: '/', redirect: '/dashboard' },
  { path: '/dashboard', component: Dashboard, meta: { auth: true } },
  { path: '/apikeys', component: ApiKeys, meta: { auth: true } },
  { path: '/plans', component: Plans, meta: { auth: true } },
  { path: '/test', component: FunctionTest, meta: { auth: true } },
  { path: '/storage', component: AzureStorage, meta: { auth: true } },
  { path: '/shop-test', component: ShopTest, meta: { auth: true } },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Authentication guard
router.beforeEach(async (to, from) => {
  console.log('Router guard: navigating from', from.path, 'to', to.path)

  // Skip auth check for login page
  if (to.path === '/login') {
    console.log('Going to login page, allowing')
    return true
  }

  // Check if route requires authentication
  if (to.meta.auth) {
    console.log('Route requires auth, checking authentication...')
    const { isAuthenticated } = await import('./services/auth')
    const authenticated = await isAuthenticated()

    console.log('Authentication result:', authenticated)

    if (!authenticated) {
      console.log('User not authenticated, redirecting to login')
      return '/login'
    } else {
      console.log('User authenticated, allowing access')
    }
  }

  return true
})

// No authentication guard - EasyAuth handles this at the API level

const app = createApp(App)
app.use(router)
app.mount('#app')
